import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Asset} from '../../../../model/asset';
import {MapService} from '../../../../services/map.service';
import {Organization} from '../../../../model/organization';
import {AssetsService} from '../../../../services/assets.service';
import {AssetSearchData} from '../../../../model/asset-search-data';
import * as mapboxgl from 'mapbox-gl';
import {Tenant} from '../../../../model/tenant';
import {ActionButton} from '../../../../model/ui/action-button';
import {translate} from '@ngneat/transloco';
import {PreviousRouteService} from '../../../../services/previous-route.service';
import {DefaultAssetRepresentation} from "../../../../model/default-asset-representation";

@Component({
  selector: 'app-devices-form-assets',
  templateUrl: './devices-form-assets.component.html',
  styleUrls: ['./devices-form-assets.component.scss']
})
export class DevicesFormAssetsComponent implements OnInit {

  public readonly DEFAULT_ZOOM = 14;
  public readonly DEFAULT_LATITUDE = 39.984;
  public readonly DEFAULT_LONGITUDE = -0.020;

  @Input() mode: 'create' | 'edit';
  @Input() asset: Asset;
  @Input() assetSearchData: AssetSearchData;
  @Input() tenant: Tenant;
  @Input() organization: Organization;
  @Input() defaultAssetRepresentation: DefaultAssetRepresentation;

  @Output() assetChange = new EventEmitter<Asset>();
  @Output() assetSearchDataChange = new EventEmitter<AssetSearchData>();
  @Output() previousStep = new EventEmitter<void>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<string>();

  public map: mapboxgl.Map;
  public marker: mapboxgl.Marker;

  assetSelectorActions: ActionButton[];
  displayAssetSelector: boolean;

  constructor(private mapService: MapService,
              private assetsService: AssetsService,
              private previousService: PreviousRouteService) {
  }

  ngOnInit(): void {
    this.buildSelectAssetActions();
    if (this.asset) {
      this.selectAsset(this.asset);
    }
  }

  private buildAndConfigureMap(): void {
    this.map = this.mapService.buildMap(this.DEFAULT_ZOOM, this.DEFAULT_LATITUDE, this.DEFAULT_LONGITUDE);
    this.marker = this.mapService.buildStaticPulsingDot(this.map, this.DEFAULT_LATITUDE, this.DEFAULT_LONGITUDE);
  }

  private buildSelectAssetActions(): void {
    this.assetSelectorActions = [
      {
        label: translate('misc.associateDeviceToAsset'),
        icon: 'pi pi-check',
        action: (asset: Asset) => {
          this.selectAsset(asset);
          this.displayAssetSelector = false;
        }
      }
    ];
  }

  selectAsset(asset: Asset): void {
    this.asset = asset;
    setTimeout(() => {
      if (!this.map) {
        this.buildAndConfigureMap();
      }
      this.map.setCenter([asset.longitude, asset.latitude]);
      this.marker?.setLngLat([asset.longitude, asset.latitude]);
    }, 0);
  }

  unselectAsset(): void {
    this.map?.remove();
    this.map = undefined;
    this.asset = undefined;
  }

  onPreviousStep(): void {
    this.previousStep.emit();
    this.assetChange.emit(this.asset);
  }

  onNextStep(): void {
    this.nextStep.emit();
    this.assetChange.emit(this.asset);
  }

  onCancel(): void {
    this.cancel.emit(this.previousService.getPreviousUrl());
  }

}
